export default {
  i18n: {
    es: {
      login: {
        title: 'Autentificar usuario',
        username: 'Usuario',
        password: 'Contraseña',
        authenticate: 'Autentificar',
        createaccount: 'Crear una cuenta',
        createguest: 'Invitado',
        links: 'Enlaces',
        platformclubs: 'clubs',
        users: 'usuarios',
        games: 'partidas y ejercios',
        samples: 'ejercicios',
        lessons: 'lecciones',
        news: 'Noticias',
        errors: {
          user_not_found: 'Usuario no encontrado',
          passw_incorrect: 'Contraseña incorrecta',
          consultando: 'Consultando'
        },
        terms: 'Terminos y condiciones',
        terms_text: 'Si continua utilizando esta plataforma acepta los términos, condiciones y las políticas de privacidad. Utilizamos cookies para darle una mejor experiencia en la plataforma.'
      },
      ELO: {
        title: 'Calculo de ELO',
        username: 'Usuario',
        password: 'Contraseña',
        authenticate: 'Autentificar',
        eloaccount: 'Calcular ELO',
        errors: {
          user_not_found: 'Usuario no encontrado',
          passw_incorrect: 'Contraseña incorrecta',
          consultando: 'Consultando'
        }
      },
      BBDD: {
        title: 'Base de datos',
        username: 'Usuario',
        password: 'Contraseña',
        authenticate: 'Autentificar',
        basedatos: 'Base de datos',
        errors: {
          user_not_found: 'Usuario no encontrado',
          passw_incorrect: 'Contraseña incorrecta',
          consultando: 'Consultando'
        }
      },
      tournament: {
        title: 'Torneos'
      },
      events: {
        title: 'Retransmisión',
        boardUpdated: 'Tablero actualizado'
      },
      listing: {
        title: 'Listado de usuarios',
        username: 'Usuario',
        password: 'Contraseña',
        authenticate: 'Autentificar',
        listaccount: 'Listar usuarios',
        errors: {
          user_not_found: 'Usuario no encontrado',
          passw_incorrect: 'Contraseña incorrecta',
          consultando: 'Consultando'
        }
      },
      register: {
        title: 'Registrar usuario',
        username: 'Usuario > 4',
        password: 'Contraseña (entre 4 y 10)',
        name: 'Nombre',
        email: 'Correo',
        codigo: 'Código',
        firstName: 'Primer Apellido',
        lastName: 'Segundo Apellido',
        club: 'Club',
        insert: 'Crear',
        cancel: 'Cancelar',
        mascul: 'Masculino',
        femen: 'Femenino',
        age: 'Edad',
        elo: 'ELO',
        edit: 'Editar',
        chat: 'Vídeo',
        chattext: 'Chat',
        chataudio: 'Audio',
        live: 'Retransmisión',
        cast: 'Emitir clases',
        analyse: 'Analizar con motor',
        download: 'Descargar PGN',
        sendtoanalyse: 'Enviar posición',
        passwordRepit: 'Repetir Password',
        admin: 'Adminitrador',
        teacher: 'Profesor',
        user: 'Usuario',
        save: 'Guardar',
        errors: {
          user_not_found: 'Usuario no encontrado',
          passw_incorrect: 'Contraseña incorrecta',
          consultando: 'Consultando'
        }
      },
      account: {
        title: 'Cuenta',
        personalData: {
          title: 'Mis datos',
          name: 'Nombre',
          username: 'Usuario',
          email: 'Correo',
          created: 'Creado',
          edit: 'Editar cuenta'
        },
        activity: {
          title: 'Actividad',
          vsPC: 'Estadísticas contra la CPU',
          vsOtherUser: 'Estadísticas humanos',
          wins: 'Ganadas',
          draws: 'Tablas',
          losses: 'Perdidos',
          whites: 'Blancas',
          blacks: 'Negras'
        }
      },
      home: {
        title: 'Inicio',
        online: 'Usuarios conectados',
        played: 'Partidas en curso',
        upload: 'Archivo',
        invite: 'Invitar',
        send: 'Enviar',
        viewer: 'Visor',
        chat: 'Vídeo',
        chattext: 'Chat',
        inviteSend: 'invitación de juego enviada',
        createPart: {
          title: 'Crear partida',
          time: 'Tiempo minutos',
          type: 'Tipo partida',
          publicAnalisis: 'Retransmitir para el club',
          typeAnalisis: 'Retransmitir para todos los clubs',
          typeBroadcast: 'Retransmisión en directo para los torneos',
          create: 'Crear',
          cancel: 'Cancelar',
          black: 'Negras',
          white: 'Blancas',
          timePersonal: 'Establecer tiempo',
          fieldTime: 'Tiempo',
          public: 'Publica',
          broadcast: 'Retransmisión',
          private: 'Privada',
          save: 'Guardar',
          close: 'Cerrar',
          incremento: 'Incremento'
        },
        uploadMens: {
          success: 'Archivos subidos correctamente',
          path_not_permit: 'Extensión de archivo no permitida',
          size_not_permit: 'Excede del tamaño permitido'
        }
      },
      invites: {
        title: 'Crear partida',
        numIn: 'Retos de usuarios',
        vspc: 'Jugar contra el ordenador',
        vsanalisis: 'Analizar partida',
        initgame: 'Iniciando juego'
      },
      visor: {
        title: 'Archivo',
        found: 'Encontrados',
        whiteName: 'Nombre blancas',
        blackName: 'Nombre negras',
        result: 'Resultado',
        wins: 'Ganan',
        by: 'por'
      },
      lesson: {
        title: 'Lecciones',
        found: 'Encontrados',
        whiteName: 'Nombre blancas',
        blackName: 'Nombre negras',
        name: 'Nombre',
        result: 'Resultado',
        wins: 'Ganan',
        by: 'por',
        option: 'Convertir el análisis en lección (aparecerá en la sección Lecciones)'
      },
      puzzles: {
        title: 'Ejercicios',
        create: {
          title: 'Crea un ejercicio',
          description: 'Añade y comparte un ejercicio',
          create: 'Crear',
          delete: 'Eliminar',
          edit: 'Editar',
          cancel: 'Cancelar',
          add: 'Añadiendo un ejercicio',
          fenInit: 'Posición inicial',
          fenFinish: 'Posición final'
        },
        list: 'Listado',
        types: {
          MateIn1: {
            name: 'Mate en 1',
            descript: 'Las blancas ganan en un movimiento'
          },
          Estrategia: {
            name: 'Estrategia',
            descript: 'Encuentra el mejor movimiento'
          },
          Finales: {
            name: 'Finales teóricos',
            descript: 'Encuentra el mejor moviento en el final'
          },
          Tactic: {
            name: 'Encontrar mejor movimiento',
            descript: 'Buscar movimiento que da como resultado otra posición'
          },
          Aperturas: {
            name: 'Estudia la apertura',
            descript: '¿Cuál es el siguiente mejor moviento en la apertura?'
          },
          Iniciacion: {
            name: 'Iniciación al ajedrez',
            descript: 'Aprende los conceptos básicos del ajedrez'
          },
          MateIn: {
            name: 'Mate en x',
            descript: 'Las blancas ganan en x movimientos'
          },
          Practica: {
            name: 'Practica',
            descript: 'Practica contra el ordenador'
          },
          Practica1: {
            name: 'Practica',
            descript: 'Practica contra el ordenador'
          },
          Practica2: {
            name: 'Practica',
            descript: 'Practica contra el ordenador'
          },
          Practica3: {
            name: 'Practica',
            descript: 'Practica contra el ordenador'
          },
          Test: {
            name: 'Test',
            descript: 'Comprueba tu nivel con diferentes ejercicios'
          },
          ConfigFEN: {
            name: 'Lógica',
            descript: 'Realiza ejercicios de lógica en el tablero'
          }
        },
        attention: 'Información',
        attMen: 'Selecciona un tipo de ejercicio a resolver',
        createBy: 'Creado por',
        date: 'Fecha',
        played: 'Juega',
        movs: 'Movimientos restantes',
        wins: 'Ganas',
        lost: 'Pierdes',
        reintent: 'Reintentar',
        intents: 'Intentos',
        color: {
          black: 'Negras',
          white: 'Blancas'
        }
      },
      practice: {
        title: 'Práctica',
        create: {
          title: 'Crea un ejercicio',
          description: 'Añade y comparte un ejercicio',
          create: 'Crear',
          delete: 'Eliminar',
          edit: 'Editar',
          cancel: 'Cancelar',
          add: 'Añadiendo un ejercicio',
          fenInit: 'Posición inicial',
          fenFinish: 'Posición final'
        },
        list: 'Listado',
        types: {
          MateIn1: {
            name: 'Mate en 1',
            descript: 'Las blancas ganan en un movimiento'
          },
          Estrategia: {
            name: 'Estrategia',
            descript: 'Encuentra el mejor movimiento'
          },
          Finales: {
            name: 'Finales teóricos',
            descript: 'Encuentra el mejor moviento en el final'
          },
          Tactic: {
            name: 'Encontrar mejor movimiento',
            descript: 'Buscar movimiento que da como resultado otra posición'
          },
          Aperturas: {
            name: 'Estudia la apertura',
            descript: '¿Cuál es el siguiente mejor moviento en la apertura?'
          },
          Iniciacion: {
            name: 'Iniciación al ajedrez',
            descript: 'Aprende los conceptos básicos del ajedrez'
          },
          MateIn: {
            name: 'Mate en x',
            descript: 'Las blancas ganan en x movimientos'
          },
          Practica: {
            name: 'Practica',
            descript: 'Practica contra el ordenador'
          },
          Practica1: {
            name: 'Practica',
            descript: 'Practica contra el ordenador'
          },
          Practica2: {
            name: 'Practica',
            descript: 'Practica contra el ordenador'
          },
          Practica3: {
            name: 'Practica',
            descript: 'Practica contra el ordenador'
          },
          Test: {
            name: 'Test',
            descript: 'Comprueba tu nivel con diferentes ejercicios'
          },
          ConfigFEN: {
            name: 'Logic',
            descript: 'Do logic exercises on the board'
          }
        },
        attention: 'Información',
        attMen: 'Selecciona un tipo de ejercicio a resolver',
        createBy: 'Creado por',
        date: 'Fecha',
        played: 'Juega',
        movs: 'Movimientos restantes',
        wins: 'Ganas',
        lost: 'Pierdes',
        reintent: 'Reintentar',
        intents: 'Intentos',
        color: {
          black: 'Negras',
          white: 'Blancas'
        }
      },
      beginner: {
        title: 'Iniciación',
        lessons: 'Lecciones',
        exercises: 'Ejercicios',
        practice: 'Práctica',
        askAI: '¿Quieres un consejo?',
        curiosity: 'Curiosidad'
      },
      clubs: {
        title: 'Clubs',
        create: {
          title: 'Crea un club',
          description: 'Añade y comparte un club',
          create: 'Crear',
          delete: 'Eliminar',
          edit: 'Editar',
          cancel: 'Cancelar',
          add: 'Añadiendo un club',
          fenInit: 'Posición inicial',
          fenFinish: 'Posición final'
        },
        list: 'Listado',
        types: {
          Liga: {
            name: 'Pago',
            descript: 'Clubs de pago'
          },
          Simultanea: {
            name: 'Escuelas',
            descript: 'Clubs de escuelas'
          },
          Suizo: {
            name: 'Suizo',
            descript: 'Torneo con emparejamiento Suizo'
          },
          Aleatorio: {
            name: 'Aleatorio',
            descript: 'Emparejamiento aleatorio'
          },
          Arena: {
            name: 'Arena',
            descript: 'Enpareja en cada ronda a los jugadores en función de su elo y puntuación'
          }
        },
        attention: 'Información',
        attMen: 'Selecciona un tipo de club',
        createBy: 'Creado por',
        date: 'Fecha',
        played: 'Juega',
        movs: 'Movimientos restantes',
        wins: 'Ganas',
        lost: 'Pierdes',
        reintent: 'Reintentar',
        intents: 'Intentos',
        color: {
          black: 'Negras',
          white: 'Blancas'
        }
      },
      torneos: {
        title: 'Torneos',
        create: {
          title: 'Crea un torneo',
          description: 'Añade y comparte un torneo',
          create: 'Crear',
          delete: 'Eliminar',
          edit: 'Editar',
          cancel: 'Cancelar',
          add: 'Añadiendo un torneo',
          fenInit: 'Posición inicial',
          fenFinish: 'Posición final'
        },
        list: 'Listado',
        types: {
          Liga: {
            name: 'Liga',
            descript: 'Todos contra todos'
          },
          Simultanea: {
            name: 'Simultanea',
            descript: 'Todos contra uno'
          },
          Suizo: {
            name: 'Suizo',
            descript: 'Torneo con emparejamiento Suizo'
          },
          Aleatorio: {
            name: 'Aleatorio',
            descript: 'Emparejamiento aleatorio'
          },
          Arena: {
            name: 'Arena',
            descript: 'Enpareja en cada ronda a los jugadores en función de su elo y puntuación'
          }
        },
        attention: 'Información',
        attMen: 'Selecciona un tipo de torneo',
        createBy: 'Creado por',
        date: 'Fecha',
        played: 'Juega',
        movs: 'Movimientos restantes',
        wins: 'Ganas',
        lost: 'Pierdes',
        reintent: 'Reintentar',
        intents: 'Intentos',
        color: {
          black: 'Negras',
          white: 'Blancas'
        }
      },
      about: {
        title: 'Acerca de',
        description: 'Información sobre la plataforma',
        namegame: 'Plataforma educativa de ajedrez',
        seemore: 'Leer más',
        des: 'Plataforma de ajedrez online. Permite dar y recibir clases en directo analizando partidas, enfrentarte a otros jugadores en tiempo real y al propio computador. Resuelve los ejercicios y crea otros nuevos.',
        tecn: 'Tecnologías',
        dev: 'Desarrollador',
        licenses: 'Licencias',
        close: 'Cerrar'
      },
      game: {
        analisys: 'Análisis',
        title: 'Partida',
        chat: 'Chat de la partida',
        rend: 'Rendir',
        chatConverTooltip: 'Selecciona un usuario conectado',
        chatConver: 'Seleccionar usuario',
        white: 'Seleccionar blancas...',
        black: 'Seleccionar negras...',
        pieces: 'Piesas',
        board: 'Tablero',
        invert: 'Invertir',
        text: 'Texto',
        check: 'Jaque a las',
        delete: 'Eliminar',
        descriptiontext: 'Enviar mensaje',
        turnColor: 'Juegan las',
        wins: 'Ganan',
        cancel: 'Partida cancelada',
        draw: 'Tablas',
        incheck: 'En jaque',
        motives: {
          time: 'por tiempo',
          rendi: 'por rendición',
          login: 'Autenticarse'
        },
        class: 'Aula',
        play: 'Jugar',
        createClass: 'Crear un análisis',
        nameClass: 'Nombre del análisis',
        accept: 'Aceptar',
        comment: 'Comentario',
        sendvideo: 'Enviar URL',
        sendfile: 'Enviar Archivo',
        pantallacompleta: 'FullScreen'
      },
      user: {
        finduser: 'Buscar usuario',
        title: 'Usuario',
        logout: 'Salir',
        login: 'Autenticarse',
        config: 'Configurar'
      }
    },
    en: {
      login: {
        title: 'user Login',
        username: 'Username',
        password: 'Password',
        authenticate: 'Login',
        createaccount: 'Create account',
        createguest: 'Guest',
        links: 'Links',
        platformclubs: 'clubs',
        users: 'users',
        games: 'games & samples',
        samples: 'samples',
        lessons: 'lessons',
        news: 'News',
        errors: {
          user_not_found: 'user not found',
          passw_incorrect: 'Incorrect password',
          consultando: 'Consulting'
        },
        terms: 'Read terms and conditions',
        terms_text: 'If you continue to use this site means you accept Terms and Conditions and Privacy Policy. We use cookies to ensure that we give you the best experience on our website.'
      },
      BBDD: {
        title: 'DataBase',
        username: 'User',
        password: 'Password',
        authenticate: 'Authenticate',
        basedatos: 'DataBase',
        errors: {
          user_not_found: 'User not found',
          passw_incorrect: 'Password incorrect',
          consultando: 'Searching'
        }
      },
      ELO: {
        title: 'Calculo de ELO',
        username: 'User',
        password: 'Password',
        authenticate: 'Authenticate',
        eloaccount: 'ELO calculate',
        errors: {
          user_not_found: 'User not found',
          passw_incorrect: 'Password incorrect',
          consultando: 'Searching'
        }
      },
      register: {
        title: 'Register user',
        username: 'Username > 4',
        password: 'Password (more than 4 and less than 10)',
        name: 'Name',
        codigo: 'Code',
        email: 'Email',
        firstName: 'Surname',
        club: 'Club',
        lastName: 'Second surname',
        insert: 'Insert',
        cancel: 'Cancel',
        mascul: 'Male',
        femen: 'Female',
        age: 'Age',
        chat: 'Vídeo',
        chattext: 'Chat',
        chataudio: 'Audio',
        live: 'Live',
        edit: 'Editar',
        cast: 'Emit',
        analyse: 'Analyse with engine',
        download: 'Download PGN',
        sendtoanalyse: 'Send position',
        passwordRepit: 'Repeat Password',
        admin: 'Admin',
        teacher: 'Teacher',
        save: 'Save',
        user: 'User',
        errors: {
          user_not_found: 'User not found',
          passw_incorrect: 'Incorrect password',
          consultando: 'Consulting'
        }
      },
      account: {
        title: 'Account',
        personalData: {
          title: 'Personal data',
          name: 'Name',
          username: 'Username',
          email: 'Email',
          created: 'Created',
          edit: 'Edit account'
        },
        activity: {
          title: 'Activity',
          vsPC: 'Stats against CPU',
          vsOtherUser: '2 Player Stats',
          wins: 'Wins',
          draws: 'Draws',
          losses: 'Losses',
          whites: 'Whites',
          blacks: 'Blacks'
        }
      },
      home: {
        title: 'Home',
        online: 'Online',
        played: 'Played',
        upload: 'File',
        invite: 'Invite',
        send: 'Send',
        viewer: 'Viewer',
        chat: 'Video',
        chattext: 'Chat',
        inviteSend: 'Game invitation sent',
        createPart: {
          title: 'Create match',
          time: 'Time minutes',
          type: 'Match type',
          publicAnalisis: 'Public',
          typeAnalisis: 'For all clubs',
          typeBroadcast: 'For broadcast',
          create: 'Create',
          cancel: 'Cancel',
          black: 'Black',
          white: 'White',
          timePersonal: 'Personal time',
          fieldTime: 'Time',
          public: 'public',
          broadcast: 'broadcast',
          private: 'private',
          save: 'Save',
          close: 'Close',
          incremento: 'Increment'
        },
        uploadMens: {
          success: 'Files Uploaded Correctly',
          path_not_permit: 'File extension not allowed',
          size_not_permit: 'Exceeds allowed size'
        }
      },
      invites: {
        title: 'Invitations',
        numIn: 'Users invitations',
        vspc: 'Play against computer',
        vsanalisis: 'Analyse',
        initgame: 'Starting game'
      },
      visor: {
        title: 'Viewer',
        found: 'Found',
        whiteName: 'White name',
        blackName: 'Black name',
        result: 'Result',
        wins: 'Wins',
        by: 'by'
      },
      lesson: {
        title: 'Lessons',
        found: 'Found',
        whiteName: 'White name',
        blackName: 'Black name',
        name: 'Name',
        result: 'Result',
        wins: 'Wins',
        by: 'by',
        option: 'Convert the analysis to a lesson (it will appear in the Lessons section)'
      },
      puzzles: {
        title: 'Puzzles',
        create: {
          title: 'Create a Puzzle',
          description: 'Add and share a challenging puzzle',
          create: 'Create',
          delete: 'Delete',
          edit: 'Edit',
          cancel: 'Cancel',
          add: 'Adding puzzle',
          fenInit: 'Initial position',
          fenFinish: 'Finish position '
        },
        list: 'List',
        types: {
          MateIn1: {
            name: 'Mate in 1',
            descript: 'White wins in one move'
          },
          Estrategia: {
            name: 'Strategic',
            descript: 'Find the best next move'
          },
          Finales: {
            name: 'Finals',
            descript: 'Best move on final game'
          },
          Tactic: {
            name: 'Tactic',
            descript: 'Find white move that results in tactic'
          },
          Iniciacion: {
            name: 'Dummy',
            descript: 'Learn about chess'
          },
          Aperturas: {
            name: 'Opennings',
            descript: 'Find best move for the openning'
          },
          MateIn: {
            name: 'Mate in x',
            descript: 'White wins in x moves'
          },
          Practica: {
            name: 'Practica',
            descript: 'Practice versus computer'
          },
          Practica1: {
            name: 'Practica',
            descript: 'Practice versus computer'
          },
          Practica2: {
            name: 'Practica',
            descript: 'Practice versus computer'
          },
          Practica3: {
            name: 'Practica',
            descript: 'Practice versus computer'
          },
          Test: {
            name: 'Test',
            descript: 'Test your level with different samples'
          }
        },
        attention: 'Attention',
        attMen: 'Select the puzzle to resolver',
        createBy: 'Create by',
        date: 'Date',
        played: 'Played',
        movs: 'Remaining moves',
        wins: 'Wins',
        lost: 'Lost',
        reintent: 'Reintent',
        intents: 'Intents',
        color: {
          black: 'black',
          white: 'white'
        }
      },
      practice: {
        title: 'Practice',
        create: {
          title: 'Create a Puzzle',
          description: 'Add and share a challenging puzzle',
          create: 'Create',
          delete: 'Delete',
          edit: 'Edit',
          cancel: 'Cancel',
          add: 'Adding puzzle',
          fenInit: 'Initial position',
          fenFinish: 'Finish position '
        },
        list: 'List',
        types: {
          MateIn1: {
            name: 'Mate in 1',
            descript: 'White wins in one move'
          },
          Estrategia: {
            name: 'Strategic',
            descript: 'Find the best next move'
          },
          Finales: {
            name: 'Finals',
            descript: 'Best move on final game'
          },
          Tactic: {
            name: 'Tactic',
            descript: 'Find white move that results in tactic'
          },
          Iniciacion: {
            name: 'Dummy',
            descript: 'Learn about chess'
          },
          Aperturas: {
            name: 'Opennings',
            descript: 'Find best move for the openning'
          },
          MateIn: {
            name: 'Mate in x',
            descript: 'White wins in x moves'
          },
          Practica: {
            name: 'Practica',
            descript: 'Practice versus computer'
          },
          Practica1: {
            name: 'Practica',
            descript: 'Practice versus computer'
          },
          Practica2: {
            name: 'Practica',
            descript: 'Practice versus computer'
          },
          Practica3: {
            name: 'Practica',
            descript: 'Practice versus computer'
          },
          Test: {
            name: 'Test',
            descript: 'Test your level with different samples'
          }
        },
        attention: 'Attention',
        attMen: 'Select the puzzle to resolver',
        createBy: 'Create by',
        date: 'Date',
        played: 'Played',
        movs: 'Remaining moves',
        wins: 'Wins',
        lost: 'Lost',
        reintent: 'Reintent',
        intents: 'Intents',
        color: {
          black: 'black',
          white: 'white'
        }
      },
      beginner: {
        title: 'Beginner',
        lessons: 'Lessons',
        exercises: 'Exercises',
        practice: 'Practice',
        askAI: 'Ask AI',
        curiosity: 'Curiosity'
      },
      clubs: {
        title: 'Clubs',
        create: {
          title: 'Create a club',
          description: 'Add and share a club',
          create: 'Create',
          delete: 'Delete',
          edit: 'Edit',
          cancel: 'Cancel',
          add: 'Adding tournament',
          fenInit: 'Initial position',
          fenFinish: 'Finish position '
        },
        list: 'List',
        types: {
          Liga: {
            name: 'League',
            descript: 'Round robin'
          },
          Simultanea: {
            name: 'Simultaneous',
            descript: 'One against all'
          },
          Suizo: {
            name: 'Swiss',
            descript: 'Swiss pairing tournament'
          },
          Aleatorio: {
            name: 'Random',
            descript: 'Random pairing'
          },
          Arena: {
            name: 'Arena',
            descript: 'Pairs each round based on players’ rating and score'
          }
        },
        attention: 'Attention',
        attMen: 'Select the club',
        createBy: 'Create by',
        date: 'Date',
        played: 'Played',
        movs: 'Remaining moves',
        wins: 'Wins',
        lost: 'Lost',
        reintent: 'Reintent',
        intents: 'Intents',
        color: {
          black: 'black',
          white: 'white'
        }
      },
      torneos: {
        title: 'Tournaments',
        create: {
          title: 'Create a tournament',
          description: 'Add and share a tournament',
          create: 'Create',
          delete: 'Delete',
          edit: 'Edit',
          cancel: 'Cancel',
          add: 'Adding tournament',
          fenInit: 'Initial position',
          fenFinish: 'Finish position '
        },
        list: 'List',
        types: {
          Liga: {
            name: 'League',
            descript: 'Round robin'
          },
          Simultanea: {
            name: 'Simultaneous',
            descript: 'One against all'
          },
          Suizo: {
            name: 'Swiss',
            descript: 'Swiss pairing tournament'
          },
          Aleatorio: {
            name: 'Random',
            descript: 'Random pairing'
          },
          Arena: {
            name: 'Arena',
            descript: 'Pairs each round based on players’ rating and score'
          }
        },
        attention: 'Attention',
        attMen: 'Select the tournament',
        createBy: 'Create by',
        date: 'Date',
        played: 'Played',
        movs: 'Remaining moves',
        wins: 'Wins',
        lost: 'Lost',
        reintent: 'Reintent',
        intents: 'Intents',
        color: {
          black: 'black',
          white: 'white'
        }
      },
      about: {
        title: 'About',
        description: 'About app',
        namegame: 'Online chess game',
        seemore: 'Read more',
        des: 'Online multiplayer chess game that will allow you to face other players in real time and the computer itself. Solve puzzles and create new ones.',
        tecn: 'Technologies',
        dev: 'Developed',
        licenses: 'Licenses',
        close: 'Close'
      },
      tournament: {
        title: 'Tournaments'
      },
      events: {
        title: 'Events',
        boardUpdated: 'Board updated'
      },
      game: {
        title: 'Game',
        analisys: 'Analisys',
        chat: 'Game´s chat',
        chatConver: 'converse with',
        chatConverTooltip: 'Select a user online',
        white: 'Select white...',
        black: 'Select black...',
        rend: 'surrend',
        pieces: 'Pieces',
        board: 'Board',
        invert: 'Invert',
        text: 'Text',
        descriptiontext: 'Send message',
        turnColor: 'Played ',
        wins: 'Wins',
        cancel: 'Game cancel',
        draw: 'Draw',
        incheck: 'in jaque',
        motives: {
          time: 'by time',
          rendi: 'by capitulation',
          login: 'Login'
        },
        class: 'Classroom',
        play: 'Play',
        createClass: 'Create a classroom',
        nameClass: 'Name of classroom',
        accept: 'Ok',
        comment: 'Comment',
        sendvideo: 'Send URL',
        sendfile: 'Send File',
        pantallacompleta: 'FullScreen'
      },
      user: {
        finduser: 'Find user',
        title: 'User',
        logout: 'Exit',
        login: 'Login',
        config: 'Config'
      },
      gametitle: {
        title: 'Mainchess'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/locales/index.js